import type { CareStateDomainDb } from '@/entities/care-state-domain';

import type { ActionReceipt } from './types';

export function getOpenRequestsCount(careState: CareStateDomainDb | null): number {
  if (careState === null) {
    return 0;
  }

  return careState.requests.reduce((count, request) => {
    if (request.status === 'Open') {
      return count + 1;
    }
    return count;
  }, 0);
}

export function formatCompletedActionTitle(title: string): string {
  // slight personal touch :)
  return title.replace(/^Send\b/, 'Sent').replace(/^send\b/, 'sent');
}

export function getActionReceipts(careState: CareStateDomainDb | null): ActionReceipt[] {
  if (careState === null) {
    return [];
  }

  return careState.proposed_actions.map((action) => ({
    externalId: action.external_id,
    title: formatCompletedActionTitle(action.title),
    status: action.run_status,
  }));
}
